import { render, staticRenderFns } from "./CodigosBarras.vue?vue&type=template&id=f12342e6&scoped=true"
import script from "./CodigosBarras.vue?vue&type=script&lang=js"
export * from "./CodigosBarras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12342e6",
  null
  
)

export default component.exports